(function() {
  let cancelCurrent = null;

  // ─── Cached DOM refs ────────────────────────────────────────────────────────
  let _priceWrapper = null;
  let _priceSaleEl  = null;
  let _priceRegEl   = null;

  function getPriceEls() {
    if (!_priceWrapper) _priceWrapper = document.querySelector('.m-price, .price');
    if (!_priceSaleEl)  _priceSaleEl  = document.querySelector('.m-price-item--sale, .price-item--sale');
    if (!_priceRegEl)   _priceRegEl   = document.querySelector('.m-price-item--regular, .price-item--regular');
  }

  // ─── Price Sync ────────────────────────────────────────────────────────────

  let _productCache = null;

  function getProductHandle() {
    return (window.location.pathname.match(/\/products\/([^/?#]+)/) || [])[1]
      || document.querySelector('[data-product-handle]')?.dataset?.productHandle;
  }

  function getSelectedVariantId() {
    return document.querySelector('product-form.m-product-form--main input[name="id"]')?.value
      || new URLSearchParams(window.location.search).get('variant');
  }

  function formatPrice(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function getVariantQuantity(variant) {
    const option = variant.options?.[0] || variant.title;
    if (/single/i.test(option)) return 1;
    const match = option.match(/^(\d+)/);
    return match ? parseInt(match[1], 10) : 1;
  }

  function updateBestvalue(priceCents, variant) {
    const qty = getVariantQuantity(variant);
    const el = _priceWrapper?.querySelector('.bestvalue');
    if (!el) return;
    if (qty <= 1) {
      el.style.display = 'none';
    } else {
      el.textContent = formatPrice(priceCents / qty) + '/ea.';
      el.style.display = '';
    }
  }

  function updateSubscriptionBadge(priceCents, compareCents) {
    getPriceEls();
    if (!_priceWrapper) return;

    const discountPct = compareCents > priceCents
      ? Math.round((1 - priceCents / compareCents) * 100)
      : 0;

    let badge = _priceWrapper.querySelector('[data-rc-save-badge]');

    if (!discountPct) {
      badge?.remove();
      return;
    }

    if (!badge) {
      badge = document.createElement('span');
      badge.setAttribute('data-rc-save-badge', '1');
      badge.style.cssText = [
        'display:inline-flex',
        'align-items:center',
        'gap:5px',
        'background:#2f27ce',
        'color:#fff',
        'font-size:12px',
        'font-weight:530',
        'letter-spacing:-0.3px',
        'padding:2px 6px',
        'border-radius:4px',
        'vertical-align:middle',
        'margin-left:10px',
        'white-space:nowrap'
      ].join(';');
      badge.innerHTML = '<svg id="a" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="8" height="10" viewBox="0 0 78.43 100" style="flex-shrink:0"><path d="M15.16,98.37c-7.17-2.81-12.41-8.88-14.38-16.66-1.94-7.68-.2-15.73,4.67-21.58L44.86,20.44H7.89V0h70.55v70.67s-19.66,0-20.4,0c0-2.72,0-5.44,0-8.16,0-5.11,0-10.22,0-15.33v-11.14s-35.84,36.08-35.84,36.08c-2.66,2.68-.76,7.24,3.01,7.24h23.63c0,3.59,0,17.52,0,20.64h-23.12c-3.41,0-6.8-.5-10.06-1.48l-.49-.15Z" fill="currentColor"/></svg><span data-rc-badge-label></span>';
      const bestvalue = _priceWrapper.querySelector('.bestvalue');
      bestvalue
        ? _priceWrapper.insertBefore(badge, bestvalue)
        : _priceWrapper.appendChild(badge);
    }

    badge.querySelector('[data-rc-badge-label]').textContent = 'Save ' + discountPct + '%';
  }

  function removeSubscriptionBadge() {
    _priceWrapper?.querySelector('[data-rc-save-badge]')?.remove();
  }

  function updateThemePriceBlock(saleCents, compareCents, variant) {
    getPriceEls();
    if (!_priceWrapper) return;
    _priceWrapper.classList.add('m-price--on-sale', 'price--on-sale');
    if (_priceSaleEl) _priceSaleEl.textContent = formatPrice(saleCents);
    if (_priceRegEl)  _priceRegEl.textContent  = formatPrice(compareCents);
    if (variant) updateBestvalue(saleCents, variant);
    updateSubscriptionBadge(saleCents, compareCents);
  }

  function restoreThemePriceBlock() {
    getPriceEls();
    if (!_priceWrapper || !_productCache) return;

    const variant = _productCache.variants.find(
      v => String(v.id) === String(getSelectedVariantId())
    );
    if (!variant) return;

    const salePrice    = variant.price;
    const comparePrice = variant.compare_at_price && variant.compare_at_price > variant.price
      ? variant.compare_at_price
      : variant.price;

    _priceWrapper.classList.add('m-price--on-sale', 'price--on-sale');
    if (_priceSaleEl) _priceSaleEl.textContent = formatPrice(salePrice);
    if (_priceRegEl)  _priceRegEl.textContent  = formatPrice(comparePrice);

    removeSubscriptionBadge();

    const bestvalueEl = _priceWrapper?.querySelector('.bestvalue');
    if (bestvalueEl) {
      const qty = getVariantQuantity(variant);
      if (qty <= 1) {
        bestvalueEl.style.display = 'none';
      } else {
        bestvalueEl.textContent = formatPrice(variant.price / qty) + '/ea.';
        bestvalueEl.style.display = '';
      }
    }
  }

  // Watch for Minimog replacing the .m-price wrapper on variant switch
  function watchPriceOverwrite(shadow) {
    const priceEl = document.querySelector('.m-price, .price');
    if (!priceEl) return;
    const parent = priceEl.parentElement;
    if (!parent || parent._rcObserved) return;
    parent._rcObserved = true;

    new MutationObserver(() => {
      _priceWrapper = null;
      _priceSaleEl  = null;
      _priceRegEl   = null;
      syncSubscriptionPrice(shadow);
    }).observe(parent, { childList: true });
  }

  async function fetchProductData() {
    if (_productCache) return _productCache;
    const handle = getProductHandle();
    if (!handle) return null;
    try {
      const res = await fetch('/products/' + handle + '.js');
      _productCache = await res.json();
      return _productCache;
    } catch (e) {
      return null;
    }
  }

  async function syncSubscriptionPrice(shadow, explicitVariantId) {
    const subOption = shadow.querySelector('.rc-purchase-option__subscription[rc-selected]');

    if (!subOption) {
      restoreThemePriceBlock();
      return;
    }

    const product = await fetchProductData();
    if (!product) return;

    const variantId = explicitVariantId
      || document.querySelector('product-form.m-product-form--main input[name="id"]')?.value
      || new URLSearchParams(window.location.search).get('variant');

    const variant = product.variants.find(v => String(v.id) === String(variantId));

    if (!variant?.selling_plan_allocations?.length) {
      restoreThemePriceBlock();
      return;
    }

    function applyAllocation() {
      const sellingPlanId = shadow.querySelector('rc-selling-plans')
        ?.shadowRoot?.querySelector('input[name="rc_plan"][checked]')?.value;
      if (!sellingPlanId) return false;

      const allocation = variant.selling_plan_allocations.find(
        a => String(a.selling_plan_id) === String(sellingPlanId)
      );
      if (!allocation) return false;

      updateThemePriceBlock(allocation.price, allocation.compare_at_price ?? variant.price, variant);
      return true;
    }

    if (!applyAllocation()) {
      let attempts = 0;
      const interval = setInterval(() => {
        if (applyAllocation() || ++attempts >= 20) clearInterval(interval);
      }, 50);
    }
  }

  // ─── Animation ─────────────────────────────────────────────────────────────

  function animateEase({ from, to, onUpdate }) {
    let current = from;
    let maxFrames = 60;
    let frameId;

    function frame() {
      if (--maxFrames <= 0) { onUpdate(to); return; }
      current += (to - current) * 0.2;
      if (Math.abs(to - current) < 0.1) { onUpdate(to); return; }
      onUpdate(current);
      frameId = requestAnimationFrame(frame);
    }

    frameId = requestAnimationFrame(frame);
    return () => cancelAnimationFrame(frameId);
  }

  function setupAnimation(shadow) {
    const subscriptionOption = shadow.querySelector('.rc-purchase-option__subscription');
    if (!subscriptionOption || subscriptionOption._rcAnimationSetup) return;
    subscriptionOption._rcAnimationSetup = true;

    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.type !== 'childList') continue;

        for (const node of m.removedNodes) {
          if (!node.classList?.contains('rc-purchase-option__sub-container') || node.dataset.rcClone) continue;

          const h = node.offsetHeight || 201;
          const clone = node.cloneNode(true);
          clone.dataset.rcClone = '1';
          clone.style.cssText += 'overflow:hidden;height:' + h + 'px;opacity:1;pointer-events:none;';

          observer.disconnect();
          subscriptionOption.appendChild(clone);
          observer.observe(subscriptionOption, { childList: true });

          if (cancelCurrent) cancelCurrent();
          cancelCurrent = animateEase({
            from: h, to: 0,
            onUpdate: v => {
              clone.style.height = v + 'px';
              clone.style.opacity = String(Math.max(v / h, 0));
              if (v <= 0.1) {
                observer.disconnect();
                clone.remove();
                observer.observe(subscriptionOption, { childList: true });
              }
            }
          });
        }

        for (const node of m.addedNodes) {
          if (!node.classList?.contains('rc-purchase-option__sub-container') || node.dataset.rcClone) continue;

          observer.disconnect();
          subscriptionOption.querySelectorAll('[data-rc-clone]').forEach(el => el.remove());
          observer.observe(subscriptionOption, { childList: true });

          injectBenefitsStyle(node.querySelector('rc-benefits'));
          injectPlansStyle(node.querySelector('rc-selling-plans'));
          injectRadioStyles(shadow);

          const benefits = node.querySelector('rc-benefits');
          const sellingPlans = node.querySelector('rc-selling-plans');
          if (benefits && sellingPlans &&
              benefits.compareDocumentPosition(sellingPlans) & Node.DOCUMENT_POSITION_FOLLOWING) {
            node.insertBefore(sellingPlans, benefits);
          }

          const newRcSP = node.querySelector('rc-selling-plans');
          if (newRcSP?.shadowRoot) {
            new MutationObserver(() => syncSubscriptionPrice(shadow))
              .observe(newRcSP.shadowRoot, {
                subtree: true,
                attributes: true,
                attributeFilter: ['checked', 'data-checked']
              });
          }

          requestAnimationFrame(() => syncSubscriptionPrice(shadow));

          requestAnimationFrame(() => {
            const h = node.scrollHeight;
            node.style.overflow = 'hidden';
            node.style.height = '0px';
            node.style.opacity = '0';

            if (cancelCurrent) cancelCurrent();
            cancelCurrent = animateEase({
              from: 0, to: h,
              onUpdate: v => {
                node.style.height = v + 'px';
                node.style.opacity = String(Math.min(v / h, 1));
                if (v >= h - 0.5) {
                  node.style.removeProperty('height');
                  node.style.removeProperty('overflow');
                  node.style.removeProperty('opacity');
                }
              }
            });
          });
        }
      }
    });

    observer.observe(subscriptionOption, { childList: true });
  }

  // ─── Style Injectors ───────────────────────────────────────────────────────

  function injectBenefitsStyle(benefitsEl) {
    if (!benefitsEl?.shadowRoot) return;
    if (benefitsEl.shadowRoot.querySelector('[data-benefits-style]')) return;
    const style = document.createElement('style');
    style.setAttribute('data-benefits-style', '1');
    style.textContent = `
      ul {
        list-style: none !important;
        padding-left: 0 !important;
        margin: 10px 0 10px !important;
      }
      li {
        font-family: var(--font-neue-montreal) !important;
        font-weight: 530 !important;
        font-size: 13px !important;
        line-height: 24px !important;
        letter-spacing: -0.3px !important;
        color: #2F27CE !important;
        padding-left: 0 !important;
        position: static !important;
        display: flex !important;
        align-items: center !important;
        gap: 10px !important;
      }
      li::before {
        content: '' !important;
        display: block !important;
        width: 14px !important;
        height: 14px !important;
        min-width: 14px !important;
        position: static !important;
        transform: none !important;
        top: unset !important;
        left: unset !important;
        flex-shrink: 0 !important;
        mask-image: none !important;
        -webkit-mask-image: none !important;
        background-color: transparent !important;
        background-size: contain !important;
        background-repeat: no-repeat !important;
        background-position: center !important;
      }
      li:nth-child(1)::before {
        background-image: url("data:image/svg+xml,%3Csvg id='a' xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'%3E%3Cpath fill='%232f27ce' d='M416%2C42.67h-32V10.67c0-5.89-4.78-10.67-10.67-10.67s-10.67%2C4.78-10.67%2C10.67v32h-213.33V10.67c0-5.89-4.78-10.67-10.67-10.67s-10.67%2C4.78-10.67%2C10.67v32h-32C43.07%2C42.67%2C0%2C85.74%2C0%2C138.67v277.33c0%2C52.93%2C43.07%2C96%2C96%2C96h85.33c5.89%2C0%2C10.67-4.78%2C10.67-10.67s-4.78-10.67-10.67-10.67h-85.33c-41.17%2C0-74.67-33.49-74.67-74.67v-224h480c5.89%2C0%2C10.67-4.78%2C10.67-10.67v-42.67c0-52.93-43.07-96-96-96ZM490.67%2C170.67H21.33v-32c0-41.17%2C33.49-74.67%2C74.67-74.67h320c41.17%2C0%2C74.67%2C33.49%2C74.67%2C74.67v32ZM420.95%2C250.28l-164.42%2C164.42c-14.1%2C14.1-21.87%2C32.85-21.87%2C52.8v33.83c0%2C5.89%2C4.78%2C10.67%2C10.67%2C10.67h33.83c19.95%2C0%2C38.7-7.77%2C52.8-21.87l164.42-164.42c10.07-10.07%2C15.62-23.47%2C15.62-37.72s-5.55-27.65-15.62-37.72c-20.12-20.14-55.3-20.14-75.41%2C0h-.02ZM481.28%2C310.61l-164.42%2C164.42c-10.07%2C10.07-23.47%2C15.62-37.72%2C15.62h-23.17v-23.17c0-14.25%2C5.55-27.63%2C15.62-37.72l164.42-164.42c12.07-12.07%2C33.17-12.07%2C45.25%2C0%2C6.04%2C6.04%2C9.37%2C14.08%2C9.37%2C22.63s-3.33%2C16.58-9.37%2C22.63h.02ZM106.65%2C287.98c0-5.89%2C4.78-10.67%2C10.67-10.67h192.02c5.89%2C0%2C10.67%2C4.78%2C10.67%2C10.67s-4.78-10.67-10.67-10.67H117.33c-5.89%2C0-10.67-4.78-10.67-10.67h-.02ZM213.31%2C394.65c0%2C5.89-4.78%2C10.67-10.67%2C10.67h-85.31c-5.89%2C0-10.67-4.78-10.67-10.67s4.78-10.67%2C10.67-10.67h85.33c5.89%2C0%2C10.67%2C4.78%2C10.67%2C10.67h-.02Z'/%3E%3C/svg%3E") !important;
      }
      li:nth-child(2)::before {
        background-image: url("data:image/svg+xml,%3Csvg id='a' xmlns='http://www.w3.org/2000/svg' width='23.98' height='24' viewBox='0 0 23.98 24'%3E%3Cpath fill='%232f27ce' d='M1%2C11.52c-.01.27-.23.48-.5.48h-.02c-.28-.01-.49-.24-.48-.52C.28%2C5.04%2C5.54%2C0%2C11.99%2C0c4.04%2C0%2C7.79%2C2.07%2C10%2C5.41V.5c0-.28.22-.5.5-.5s.5.22.5.5v5c0%2C.83-.67%2C1.5-1.5%2C1.5h-5c-.28%2C0-.5-.22-.5-.5s.22-.5.5-.5h4.69c-2.02-3.09-5.47-5-9.19-5C6.08%2C1%2C1.25%2C5.62%2C1%2C11.52ZM23.5%2C12c-.32-.02-.51.2-.52.48-.25%2C5.9-5.08%2C10.52-10.99%2C10.52-3.72%2C0-7.17-1.91-9.19-5h4.69c.28%2C0%2C.5-.22.5-.5s-.22-.5-.5-.5H2.49c-.83%2C0-1.5.67-1.5%2C1.5v5c0%2C.28.22.5.5.5s.5-.22.5-.5v-4.91c2.21%2C3.35%2C5.96%2C5.41%2C10%2C5.41%2C6.45%2C0%2C11.71-5.04%2C11.99-11.48.01-.28-.2-.51-.48-.52Z'/%3E%3C/svg%3E") !important;
      }
    `;
    benefitsEl.shadowRoot.appendChild(style);
  }

  function injectPlansStyle(sellingPlansEl) {
    if (!sellingPlansEl?.shadowRoot) return;
    if (sellingPlansEl.shadowRoot.querySelector('[data-plans-style]')) return;
    const style = document.createElement('style');
    style.setAttribute('data-plans-style', '1');
    style.textContent = `
      .rc-plans__label {
        font-family: var(--font-mono) !important;
        font-size: 12px !important;
        font-weight: 450 !important;
        letter-spacing: -0.3px !important;
        margin-bottom: 0 !important;
      }
      .rc-plans-button__interval {
        flex-direction: row !important;
        font-family: var(--font-neue-montreal) !important;
        font-size: 13px !important;
        font-weight: 530 !important;
        gap: 8px;
        letter-spacing: -0.2px !important;
      }
      .rc-plans-button__discount {
        font-family: var(--font-neue-montreal) !important;
        font-size: 12px !important;
        letter-spacing: -0.2px !important;
      }
      fieldset.rc-plans-button-group {
        display: grid !important;
        grid-template-columns: repeat(4, 1fr) !important;
        gap: 8px !important;
        width: 100% !important;
        padding: 0 !important;
        border: 0 !important;
        margin: 0 !important;
        box-sizing: border-box !important;
      }
      @media (max-width: 749px) {
        fieldset.rc-plans-button-group {
          grid-template-columns: repeat(2, 1fr) !important;
        }
      }
      label[part="rc-plans-radio-button"] {
        width: 100% !important;
        min-width: 0 !important;
      }
      .rc-plans-button {
        width: 100% !important;
        min-width: 0 !important;
        box-sizing: border-box !important;
        text-align: center !important;
        transition: all 0.2s ease !important;
        background: #f5f5f5 !important;
        border-radius: 8px !important;
        border: 1px solid #f5f5f5 !important;
      }
      .rc-plans-button:hover {
        background: #f5f5f5 !important;
        color: #222 !important;
        border: 1px solid #222 !important;
      }
      .rc-plans-button[data-checked] {
        background: #222222 !important;
        color: #fff !important;
        border: 1px solid #222 !important;
      }
    `;
    sellingPlansEl.shadowRoot.appendChild(style);
  }

  function injectRadioStyles(shadow) {
    shadow.querySelectorAll('rc-radio-icon').forEach(icon => {
      if (!icon.shadowRoot || icon.shadowRoot.querySelector('[data-radio-style]')) return;
      const style = document.createElement('style');
      style.setAttribute('data-radio-style', '1');
      style.textContent = `
        circle { fill: #2F27CE !important; transform-origin: center; transform: scale(1.25); }
        rect:last-of-type { stroke: #2F27CE !important; }
      `;
      icon.shadowRoot.appendChild(style);
    });
  }

  // ─── Customize (runs once per render cycle) ────────────────────────────────

  function customize(shadow, host) {
    if (shadow.querySelector('style[data-rc-custom]')) return true;

    const sub = shadow.querySelector('.rc-purchase-option__sub-container');
    const benefits = sub?.querySelector('rc-benefits');
    const sellingPlans = sub?.querySelector('rc-selling-plans');
    if (!sub || !benefits || !sellingPlans) return false;

    if (benefits.compareDocumentPosition(sellingPlans) & Node.DOCUMENT_POSITION_FOLLOWING) {
      sub.insertBefore(sellingPlans, benefits);
    }

    injectBenefitsStyle(benefits);
    injectPlansStyle(shadow.querySelector('rc-selling-plans'));
    injectRadioStyles(shadow);

    // Badge percent sync
    const badge = shadow.querySelector('#rc-subscription-badge');
    const labelSelector = shadow.querySelector('.rc-purchase-option__selector');
    if (badge && labelSelector) {
      function syncBadgeText() {
        const match = badge.textContent.trim().match(/(\d+%)/);
        const percentText = match ? match[1] : badge.textContent.trim();
        let percentSpan = labelSelector.querySelector('[data-rc-badge-text]');
        if (!percentSpan) {
          percentSpan = document.createElement('span');
          percentSpan.setAttribute('data-rc-badge-text', '1');
          percentSpan.style.cssText = 'margin-left:0.25em;';
          const learnMore = labelSelector.querySelector('rc-learn-more');
          learnMore
            ? labelSelector.insertBefore(percentSpan, learnMore)
            : labelSelector.appendChild(percentSpan);
        }
        if (percentSpan.textContent !== percentText) percentSpan.textContent = percentText;
      }

      syncBadgeText();

      if (!badge._rcBadgeWatcher) {
        badge._rcBadgeWatcher = true;
        new MutationObserver(syncBadgeText).observe(badge, {
          childList: true, subtree: true, characterData: true
        });
      }
    }

    const style = document.createElement('style');
    style.setAttribute('data-rc-custom', '1');
    style.textContent = `
      [part~="rc-purchase-option__onetime"] [part~="rc-purchase-option__selector_onetime"] {
        font-size: 14px !important;
        color: #222 !important;
        font-weight: 450 !important;
      }
      [part~="rc-purchase-option__onetime"] .rc-price {
        font-size: 14px !important;
        color: #222 !important;
        font-weight: 450 !important;
      }
      .rc-price { letter-spacing: -0.1px !important; }
      .text-muted { font-size: 12px !important; font-weight: 450 !important; }
      .rc-purchase-option:not(:last-child) { margin-bottom: 0 !important; }
      .rc-purchase-option__selector {
        font-family: var(--font-neue-montreal) !important;
        font-size: 18px !important;
        font-weight: 700 !important;
        letter-spacing: -0.2px !important;
        color: #111 !important;
      }
      .rc-purchase-option { border: 1px solid transparent !important; }
      .rc-purchase-option[rc-selected] {
        border-radius: 8px !important;
        background: #fff !important;
        border: 1px solid #2f27ce !important;
      }
      .compact .rc-purchase-option__label { border-radius: 12px !important; }
      .rc-purchase-option__sub-container {
        padding: 0 20px !important;
        background: #fff !important;
        border-radius: 20px !important;
        overflow: hidden !important;
        will-change: height, opacity !important;
      }
      svg.rc-checked-icon rect { fill: unset !important; }
      .rc-purchase-option__checked-indicator {
        margin-right: 5px;
        background: #fff !important;
        border-radius: 99999px !important;
      }
      .rc-price { font-size: 16px; font-weight: 700 !important; }
      .rc-price .strike-through { font-weight: 530 !important; }
      .rc-purchase-option__badge {
        display: flex;
        gap: 6px;
        align-items: center;
        position: absolute;
        width: fit-content !important;
        padding: 4px 8px !important;
        background: var(--rc-widget-badge-bg-color);
        color: var(--rc-widget-badge-text-color);
        font-size: 11px !important;
        font-family: var(--font-neue-montreal) !important;
        font-weight: 530 !important;
        line-height: 1 !important;
        letter-spacing: 0 !important;
        text-transform: none !important;
        border-radius: 4px !important;
      }
      .rc-purchase-option__subscription { --rc-widget-brand-color: #111; }
    `;
    shadow.appendChild(style);

    setupAnimation(shadow);
    syncSubscriptionPrice(shadow);
    return true;
  }

  // ─── Price signal watchers ──────────────────────────────────────────────────

  function watchPriceSignals(shadow) {
    if (shadow._rcPriceWatcher) return;
    shadow._rcPriceWatcher = true;

    shadow.querySelectorAll('rc-purchase-option').forEach(opt => {
      new MutationObserver(() => syncSubscriptionPrice(shadow))
        .observe(opt, { attributes: true, attributeFilter: ['rc-selected'] });
    });

    function watchSellingPlansShadow() {
      const rcSP = shadow.querySelector('rc-selling-plans');
      if (!rcSP?.shadowRoot || rcSP._rcPlanWatcher) return;
      rcSP._rcPlanWatcher = true;
      new MutationObserver(() => syncSubscriptionPrice(shadow))
        .observe(rcSP.shadowRoot, {
          subtree: true,
          attributes: true,
          attributeFilter: ['checked', 'data-checked']
        });
    }

    watchSellingPlansShadow();

    new MutationObserver(watchSellingPlansShadow)
      .observe(shadow, { childList: true });

    shadow.addEventListener('change', () => syncSubscriptionPrice(shadow), true);
  }

  // ─── watchShadow ───────────────────────────────────────────────────────────

  function watchShadow(shadow, host) {
    let lastKnownHeight = host.offsetHeight;
    let wasEmpty = false;

    new MutationObserver(() => {
      const h = host.offsetHeight;
      if (h > 0) lastKnownHeight = h;
    }).observe(host, { attributes: true, attributeFilter: ['style'] });

    const observer = new MutationObserver(() => {
      const isEmpty = shadow.childNodes.length === 0 ||
        [...shadow.childNodes].every(n => n.nodeType === 8);

      const h = host.offsetHeight;
      if (h > 0) lastKnownHeight = h;

      if (isEmpty && !wasEmpty) {
        wasEmpty = true;
        const fromHeight = lastKnownHeight;

        if (cancelCurrent) cancelCurrent();

        host.style.setProperty('position', 'absolute', 'important');
        host.style.setProperty('width', host.offsetWidth + 'px', 'important');
        host.style.setProperty('height', fromHeight + 'px', 'important');
        host.style.setProperty('padding', '0', 'important');
        host.style.setProperty('overflow', 'hidden', 'important');
        host.style.setProperty('opacity', '1', 'important');
        host.style.setProperty('background', 'transparent', 'important');

        cancelCurrent = animateEase({
          from: fromHeight, to: 0,
          onUpdate: v => {
            host.style.setProperty('height', v + 'px', 'important');
            host.style.setProperty('opacity', String(Math.max(v / fromHeight, 0)), 'important');
            if (v <= 0.1) {
              host.style.setProperty('height', '0px', 'important');
              requestAnimationFrame(() => {
                host.style.removeProperty('height');
                host.style.removeProperty('overflow');
                host.style.removeProperty('opacity');
              });
            }
          }
        });

        restoreThemePriceBlock();

      } else if (!isEmpty && wasEmpty) {
        wasEmpty = false;
        shadow.querySelector('style[data-rc-custom]')?.remove();
        shadow._rcPriceWatcher = false;

        host.style.removeProperty('position');
        host.style.removeProperty('width');
        host.style.removeProperty('padding');
        host.style.removeProperty('background');

        if (!customize(shadow, host)) {
          const reRenderObserver = new MutationObserver(() => {
            if (customize(shadow, host)) {
              reRenderObserver.disconnect();
              watchPriceSignals(shadow);
            }
          });
          reRenderObserver.observe(shadow, { childList: true, subtree: true });
        } else {
          watchPriceSignals(shadow);
        }

        requestAnimationFrame(() => {
          const naturalHeight = host.scrollHeight;
          lastKnownHeight = naturalHeight;

          if (cancelCurrent) cancelCurrent();

          host.style.setProperty('height', '0px', 'important');
          host.style.setProperty('overflow', 'hidden', 'important');
          host.style.setProperty('opacity', '0', 'important');

          cancelCurrent = animateEase({
            from: 0, to: naturalHeight,
            onUpdate: v => {
              host.style.setProperty('height', v + 'px', 'important');
              host.style.setProperty('opacity', String(Math.min(v / naturalHeight, 1)), 'important');
              if (v >= naturalHeight - 0.5) {
                host.style.removeProperty('height');
                host.style.removeProperty('overflow');
                host.style.removeProperty('opacity');
              }
            }
          });
        });
      }
    });

    observer.observe(shadow, { childList: true });

    if (!customize(shadow, host)) {
      const initObserver = new MutationObserver(() => {
        if (customize(shadow, host)) {
          initObserver.disconnect();
          watchPriceSignals(shadow);
        }
      });
      initObserver.observe(shadow, { childList: true, subtree: true });
    } else {
      watchPriceSignals(shadow);
    }

    watchPriceOverwrite(shadow);

    const mainIdInput = document.querySelector('product-form.m-product-form--main input[name="id"]');
    mainIdInput?.addEventListener('change', (e) => syncSubscriptionPrice(shadow, e.target.value));
  }

  // ─── Boot ──────────────────────────────────────────────────────────────────

  function watchForHost() {
    const host = document.querySelector('recharge-subscription-widget');
    if (host?.shadowRoot) {
      watchShadow(host.shadowRoot, host);
      return;
    }

    const observer = new MutationObserver(() => {
      const host = document.querySelector('recharge-subscription-widget');
      if (host?.shadowRoot) {
        observer.disconnect();
        watchShadow(host.shadowRoot, host);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  fetchProductData();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchForHost);
  } else {
    watchForHost();
  }
})();